import axios from "axios"
import VueAxios from "vue-axios"
let baseurl = "";
if(process.env.NODE_ENV === 'production'){
	 // baseurl = "http://xunjian.hebeilingyan.com/";
	 baseurl = "https://maintenance.richglorytech.com.tw/xunjian/public/index.php/";
}else{
	 baseurl = "/admin";
}
export const request = (options)=>{
	return new Promise((resolve,reject)=>{
      let data = options.data || "";
      if(options.method=="post"){
          axios.post(baseurl+options.url,data).then((res)=>{
            resolve(res);
          }).catch((err)=>{
            reject(err);
          });
      }else{
        axios.get(baseurl+options.url,{params:data}).then((res)=>{
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      }
	})
}



// WEBPACK FOOTER //
// ./src/common/request.js